// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDarcatalogmgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDarcatalogmgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDarcatalogmgrIconOutlined = function DrrpDarcatalogmgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDarcatalogmgrIconOutlinedSvg
  }));
};

DrrpDarcatalogmgrIconOutlined.displayName = 'DrrpDarcatalogmgrIconOutlined';
export default React.forwardRef(DrrpDarcatalogmgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDarcatalogmgrIconOutlined.js
// module id = 2517
// module chunks = 0